import type { Product } from '~/models/Product'
import { externalClient } from '~/api/client/externalClient'
import { contentClient } from '~/api/client/contentClient'

export default function useProductsApi() {
  const getOpenProducts = async (): Promise<Product[]> => {
    return (await contentClient.get('/account/products/open')).data
  }

  const getLicensedProducts = async (language: string): Promise<Product[]> => {
    return (await externalClient.get(`/frontend/licenses/products?site=AUNIVERS,GAN&preferredLangague=${language}`)).data
  }

  return {
    getOpenProducts,
    getLicensedProducts,
  }
}
